



















































































































import Vue from 'vue';
import StatsService from '@/api/stats.service';
import EventBus from '@/helpers/event-bus';
import { LOAD_STATE } from '@/store/shared';
import { IReactivationStats, ISession, LoadState } from '@/store/types';
import { formatPercent, formatSmallMoney, formatSmallNumber } from '@/helpers/jsUtils';
import OverallLoader from '@/components/UI/Loader/OverallLoader.vue';
import HeaderLoader from '@/components/UI/Loader/HeaderLoader.vue';
import { mapGetters, mapState } from 'vuex';

export default Vue.extend({
  name: 'OvervallPerformance',
  components: {
    HeaderLoader,
    OverallLoader,
  },
  data() {
    return {
      reactivationRates: null as IReactivationStats | null,
      loadState: LOAD_STATE.LOADING as LoadState,
      LOAD_STATE,
      formatSmallMoney,
      formatPercent,
      formatSmallNumber,
      cancelCount: 0,
      saveCount: 0,
      sessionCount: 0,
    };
  },
  async created() {
    try {
      const rstats = await StatsService.reactivationStats({});
      if (rstats && rstats.length) {
        this.reactivationRates = rstats[0];
      }
      const sstats = await StatsService.sessionOutcomes({});
      if (sstats && sstats.length) {
        this.sessionCount = sstats.reduce((sum, d) => sum + d.count, 0);
        this.saveCount = sstats.reduce((sum, d) => (!d.canceled ? sum + d.count : sum), 0);
        this.cancelCount = sstats.reduce((sum, d) => (d.canceled ? sum + d.count : sum), 0);
      }
      this.loadState = LOAD_STATE.LOADED;
      EventBus.$emit('dashboard-overall-loaded');
    } catch (e) {
      console.log(e);
      this.loadState = LOAD_STATE.ERROR_LOADING;
    }
  },
  computed: {
    ...mapGetters(['lowData', 'daysSinceOrgCreated', 'confidential']),
    sessions(): ISession[] {
      return this.$store.state.recentSessions;
    },
    loading(): boolean {
      return this.$store.state.recentSessionsLoadState !== LOAD_STATE.LOADED;
    },
    lowVolume(): boolean {
      return this.lowData || this.daysSinceOrgCreated < 45;
    },
  },
});
